import NavigateBack from "../components/navigateBack";
import { useTranslation } from "react-i18next";
import { ReactComponent as TestsIcon } from "../img/icons/icon_prescribedtests.svg";
import { ReactComponent as ReportsIcon } from "../img/icons/icon_reports.svg";
import { useHistory } from "react-router-dom";

//TODO: rename classes with prefer Test
function TestReportsLanding() {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <>
      <NavigateBack title={t("testReports.title")} />
      <div className="body_content py-5">
        <div className="inner_body">
          <ul className="list-unstyled list_testreports">
            <li>
              <a href="#">
                <span className="icon">
                  <TestsIcon />
                  {/*<span className="txt_val_dot">1</span>*/}
                </span>
                <span className="txt">{t("testReports.testsOption")}</span>
                <span className="coming_soon">
                  {" (" + t("appointment.MYCLINIC.coming") + ")"}
                </span>
              </a>
              {/*
              <a onClick={() => history.push("/my-tests")}>
                <span className="icon">
                  <TestsIcon />
                  {<span className="txt_val_dot">1</span>}
                </span>
                <span className="txt">{t("testReports.testsOption")}</span>
              </a>
              */}
            </li>
            <li>
              <a onClick={() => history.push("/my-reports")}>
                <span className="icon">
                  <ReportsIcon />
                </span>
                <span className="txt">{t("testReports.reportsOption")}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default TestReportsLanding;
